import BtnHamburger, {
	BtnHamburgerProps as _BtnHamburgerProps,
} from './BtnHamburger';

export { BtnHamburger };
export type BtnHamburgerProps = _BtnHamburgerProps;
